// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onfido-sdk-ui-Complete-wrapper{margin-top:7.25em}.onfido-sdk-ui-Complete-icon{height:4em;margin-bottom:.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_animation_duration": "200ms",
	"wrapper": "onfido-sdk-ui-Complete-wrapper",
	"icon": "onfido-sdk-ui-Complete-icon"
};
export default ___CSS_LOADER_EXPORT___;
